import {SidebarPackages as PackagesComponent} from '@github-ui/code-view-sidebar/components/SidebarPackages'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarPackagesResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarPackages(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarPackagesCombined {...props} />
  ) : (
    <SidebarPackagesIndividual {...props} />
  )
}

function SidebarPackagesCombined({ownerLogin, repoName}: Props) {
  const {packages} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!packages) return null
  return <PackagesComponent {...packages} />
}

function SidebarPackagesIndividual({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'packages', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/packages`)
      if (!r.ok) throw new Error(`Sidebar packages fetch failed (${r.status})`)
      return (await r.json()) as SidebarPackagesResponse
    },
  })

  if (!data) return null
  return <PackagesComponent {...data} />
}
